import { Dispatch } from '@reduxjs/toolkit'

import { getTrack as getTrackApiCall } from '@/helpers/api/tracksApi'
import { getErrorResponse } from '@/helpers/getErrorResponse'
import { LogResource, TrackResource } from '@/models'
import {
    SET_LOADING,
    TRACK_FAILURE,
    TRACK_REQUEST,
    TRACK_SUCCESS,
} from '@/redux/actionTypes'

export const getTrack = (trackUuid: string) => async (dispatch: Dispatch): Promise<void> => {
    dispatch({ type: SET_LOADING, loading: true })
    dispatch({ type: TRACK_REQUEST })

    try {
        const includes = ['shift', 'shift.department', 'shift.shiftPlannings', 'feedback', 'logs']

        const response = await getTrackApiCall(includes, trackUuid)
        const track: TrackResource = response.data
        if (track.logs) {
            track.logs = track.logs.filter((log: LogResource) => log.version !== 1)
        }

        dispatch({
            type: TRACK_SUCCESS,
            track,
        })
    } catch (error) {
        dispatch({ type: TRACK_FAILURE, errors: [getErrorResponse(error)] })
    }

    dispatch({ type: SET_LOADING, loading: false })
}
